import React from "react";
import { Link } from "react-router-dom";

const AddOrgButton = (): React.JSX.Element => {
    return (
        <Link
            to={`/league-management/organizations/add`}
            className="btn btn-primary createButton mt-0"
        >
            Add New Organization
        </Link>
    );
};

export default AddOrgButton;
